import { SecureRoute } from "@okta/okta-react";
import { Route, Redirect } from 'react-router-dom';

interface PrivateRouteProps {
    path: string;
    component: React.ComponentType<any> | undefined;
    requiredClaim?: string;
    requiredValue?: boolean;
}

export const PrivateRoute = ({
    path,
    component: Component,
    requiredClaim,
    requiredValue = true,
    ...rest
}: PrivateRouteProps) => {
    const userDetailsStr = localStorage.getItem('userDetails');
    const userDetails = userDetailsStr ? JSON.parse(userDetailsStr) : null;

    const hasRequiredAccess = requiredClaim
        ? userDetails?.[requiredClaim] === requiredValue
        : true;

    return (
        <Route
            path={path}
            {...rest}
            render={(props) =>
                hasRequiredAccess ? (
                    <SecureRoute component={Component} path={path} {...props} />
                ) : (
                    <Redirect to="/" />
                )
            }
        />
    );
};
